import { apiSearchContactsByProps } from '../api';

/**
 * Searches for an existing company by name and returns its ID if found.
 * Prefers exact name match (shortName/fullName), falls back to single-result match.
 */
export async function resolveCompanyId(
  companyName: string,
  signal?: AbortSignal
): Promise<string | undefined> {
  try {
    const safeName = companyName.replace(/'/g, "''");
    const searchString = encodeURIComponent(
      `QuickSearch like '${safeName}' & CompanyContact eq 'Company' & InternalExternal eq 'External'`
    );
    const { result, data } = await apiSearchContactsByProps(
      searchString,
      1000,
      false,
      signal
    );

    if (result.status >= 200 && result.status < 300 && data) {
      const items = data.items || [];
      const companyNameLower = companyName.toLowerCase();
      const exactMatch = items.find(
        (item) =>
          item.data?.company?.companyId &&
          !item.data?.company?.isArchived &&
          (item.data?.company?.shortName?.toLowerCase() === companyNameLower ||
            item.data?.company?.fullName?.toLowerCase() === companyNameLower)
      );
      if (exactMatch) {
        return exactMatch.data.company.companyId;
      }
      if (
        items.length === 1 &&
        items[0].data?.company?.companyId &&
        !items[0].data?.company?.isArchived
      ) {
        return items[0].data.company.companyId;
      }
    }
  } catch (error) {
    if (error?.name === 'AbortError') throw error;
    console.error('Company search failed:', error);
  }
  return undefined;
}
